import { ICharger } from "@src/types/charging";

const getCharger = (chargers: ICharger[], type: ICharger["type"]) => {
  return chargers.filter((charger) => charger.type === type)[0];
};

export default getCharger;
